const initializePasswordToggles = (root = document) => {
    root.querySelectorAll('[data-password-toggle]').forEach((button) => {
        if (button.dataset.passwordToggleInitialized === 'true') {
            return;
        }

        const selector = button.dataset.passwordTarget;
        const input = selector
            ? document.querySelector(selector)
            : null;

        if (!(input instanceof HTMLInputElement)) {
            return;
        }

        button.dataset.passwordToggleInitialized = 'true';

        button.addEventListener('click', () => {
            const showPassword = input.type === 'password';

            input.type = showPassword ? 'text' : 'password';

            const icon = button.querySelector('[data-password-icon]');

            if (icon) {
                icon.className = showPassword
                    ? 'bi bi-eye-slash'
                    : 'bi bi-eye';
            }

            button.setAttribute(
                'aria-label',
                showPassword
                    ? 'Passwort ausblenden'
                    : 'Passwort anzeigen'
            );
        });
    });
};

export {
    initializePasswordToggles,
};
